const e = new URL("../../assets/icon-user-profile-CQLiEd4A.png", import.meta.url).href;
export {
  e as default
};
//# sourceMappingURL=icon-user-profile.png.js.map
